import { LOG_LEVEL_ORDER } from './constants';

import type { LogLevel } from './types';

/**
 * Runtime configuration for the logger.
 *
 * directConsolePrinter defaults to NODE_ENV === 'development' but can be
 * overridden at init time — useful for staging environments that want
 * console output without changing NODE_ENV.
 */
let _directConsolePrinter: boolean | undefined;

export const setDirectConsolePrinter = (enabled: boolean): void => {
  _directConsolePrinter = enabled;
};

export const isDirectConsolePrinter = (): boolean =>
  _directConsolePrinter ??
  (process.env.NEXT_PUBLIC_LOG_DIRECT_CONSOLE_PRINTER === 'true' ||
    process.env.NODE_ENV === 'development');

/**
 * Parses a log level string from an environment variable.
 * Falls back to the provided default if the value is absent or invalid.
 */
export const parseLogLevel = (
  value: string | undefined,
  fallback: LogLevel,
): LogLevel =>
  value && Object.hasOwn(LOG_LEVEL_ORDER, value)
    ? (value as LogLevel)
    : fallback;
